export { registerComponent as registerTextComponent } from '../../components/builtin/Text/register'
export { default as Text } from '../../components/builtin/Text/Text'
